export default {
  title: 'Ondertekend / Live rapport',
  column_groups: {
    current_period: 'Huidige periode',
  },
  fields: {
    name: 'Naam',
    area: 'Gebied',
    signed: 'Ondertekend',
    live: 'Live',
    going_live: 'Live gaan',
    going_live_avg: 'Gem. live gaan',
    churned: 'Opgezegd',
    not_live: 'Niet live',
    live_ratio: 'Live-ratio',
    avg_mrr: 'Gem. MRR',
  },
  manager_status_filters: {
    active: 'Actief',
    inactive: 'Inactief',
    all: 'Alle',
  },
  status_filters: {
    all: 'Alle',
    not_live: 'Niet live',
  },
  drawer: {
    title: '{{column}} — {{managerName}}',
    subtitle_one: '{{count}} restaurant',
    subtitle_other: '{{count}} restaurants',
    empty: 'Geen restaurants gevonden.',
  },
  toasts: {
    failed_to_load_data: 'Laden van gegevens mislukt, vernieuw de pagina',
  },
};
